
define('text!templates/modules/questionnaire/responses/response-list-item.html',[],function () { return '<div class="item-section"></div>\n';});

